// extracted by mini-css-extract-plugin
export default {"BlockedSectionMessage":"BlockedSection-module__BlockedSectionMessage__z5O597l","CircleOcticon":"BlockedSection-module__CircleOcticon__oUmHbNh"};